<mat-card class="trinta-card mb-25 bg-white border-none d-block chart-card">
  <mat-card-header class="d-flex justify-content-between align-items-center">
    <mat-card-title>
      <h5 class="mt-0 mb-0">DUS por Tipo de Atraso</h5>
    </mat-card-title>
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Opciones">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu" xPosition="before">
      <button mat-menu-item (click)="downloadSvg()">
        <mat-icon>image</mat-icon>
        <span>Descargar SVG</span>
      </button>
      <button mat-menu-item (click)="downloadPng()">
        <mat-icon>image</mat-icon>
        <span>Descargar PNG</span>
      </button>
      <button mat-menu-item (click)="downloadCsv()">
        <mat-icon>description</mat-icon>
        <span>Descargar CSV</span>
      </button>
    </mat-menu>
  </mat-card-header>
  <mat-card-content>
    <div class="progress-list" *ngIf="items.length > 0">
      @for (item of items; track item.label; let i = $index) {
      <div class="progress-item">
        <div class="progress-header">
          <span class="progress-label" [title]="item.label">{{ item.label }}</span>
          <div class="progress-stats">
            <span class="progress-value">{{ item.value }}</span>
            <span class="progress-percent">{{ item.percent }}%</span>
          </div>
        </div>
        <div class="progress-bar-container">
          <div class="progress-bar-fill" [style.width.%]="item.widthPercent" [style.background-color]="item.color">
          </div>
        </div>
      </div>
      }
    </div>
    <div class="empty-state" *ngIf="items.length === 0">
      <span>Sin datos disponibles</span>
    </div>
  </mat-card-content>
</mat-card>